import { useMedia } from "./useMedia";

type SignatureType = EasyTech.Photo | EasyTech.WorkorderSignature;

interface UseSignaturesOptions {
  workorderId: string;
  initialSignatures: SignatureType[];
}

export const useSignatures = ({ workorderId, initialSignatures }: UseSignaturesOptions) => {
  const media = useMedia({
    workorderId,
    initialMedia: initialSignatures,
    endpoint: "signatures"
  });

  return {
    signatures: media.media,
    loadingType: media.loadingType,
    error: media.error,
    loading: media.loading,
    uploadSignature: media.uploadMedia,
    deleteSignature: media.deleteMedia,
    reloadSignatures: media.reloadMedia,
    setSignatures: media.setMedia,
    getDownloadUrl: media.getDownloadUrl
  };
};